<template>
  <q-card style="q-pa-md">
    <q-card-section
      ><q-icon name="today" color="indigo" />
      <div class="text-h6 text-indigo">Bugunku Randevular</div>
    </q-card-section>
    <q-card-section> Bugune kaydedilmis randevular </q-card-section>
    <q-card-section class="q-pt-none">
      <div class="row">
        <div class="col-4 q-pa-md">
          <q-card flat bordered class="my-card">
            <q-card-section>
              <div class="text-h6">Tanisma Randevulari</div>
            </q-card-section>
            <q-card-section
              v-for="(appointment, index) in appointments.get('INTRODUCTION')"
              :key="index"
              class="q-pt-none"
            >
              {{ appointmentText(appointment) }}
            </q-card-section>
          </q-card>
        </div>
        <div class="col-4 q-pa-md">
          <q-card flat bordered class="my-card">
            <q-card-section>
              <div class="text-h6">Diyet Seansi</div>
            </q-card-section>
            <q-card-section
              v-for="(appointment, index) in appointments.get('REGIME_SESSION')"
              :key="index"
              class="q-pt-none"
            >
              {{ appointmentText(appointment) }}
            </q-card-section>
          </q-card>
        </div>
        <div class="col-4 q-pa-md">
          <q-card flat bordered class="my-card">
            <q-card-section>
              <div class="text-h6">Bolgesel Zayiflama</div>
            </q-card-section>
            <q-card-section
              v-for="(appointment, index) in appointments.get('REGIONAL_LOSS')"
              :key="index"
              class="q-pt-none"
            >
              {{ appointmentText(appointment) }}
            </q-card-section>
          </q-card>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import { ref } from 'vue'
import axios from 'axios'
import moment from 'moment'
import * as timestuff from '../../utils/timetravel'

export default {
  setup() {
    const appointments = ref(new Map())

    // Start and End of the current day to query appointments
    const start = moment().startOf('day').toISOString()
    const end = moment().endOf('day').toISOString()

    axios.get(`/appointments?start=${start}&end=${end}`).then((response) => {
      response.data.forEach((appointment) => {
        // Initialize appointment array for the 'type'
        if (!appointments.value.get(appointment.appointmentType)) {
          appointments.value.set(appointment.appointmentType, [])
        }

        // Add appointment to the array
        appointments.value.get(appointment.appointmentType).push(appointment)
        console.log(appointments.value)
      })
    })

    /**
     * Pretty print the appointment details
     * [StartTime-EndTime] - Customer Name
     */
    function appointmentText(appointment) {
      return (
        timestuff.humanReadableAppointmentTime(
          appointment.appointmentStart,
          appointment.appointmentEnd
        ) +
        ' ' +
        appointment.customerName
      )
    }

    return {
      appointments,
      appointmentText,
    }
  },
}
</script>
